"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.purchaseTypeMapper = void 0;
var enum_mapper_1 = require("../utils/enum-mapper");
var enums_1 = require("@wix/wix-vod-constants/dist/api-types/enums");
var globalTypes_1 = require("../public/generated/globalTypes");
exports.purchaseTypeMapper = new enum_mapper_1.EnumMapper((_a = {},
    _a[globalTypes_1.PurchaseType.RENT] = enums_1.PaymentType.RENT,
    _a[globalTypes_1.PurchaseType.SALE] = enums_1.PaymentType.PURCHASE,
    _a[globalTypes_1.PurchaseType.SUBSCRIPTION] = enums_1.PaymentType.SUBSCRIPTION,
    _a));
//# sourceMappingURL=purchase-type.js.map